function SamsaOffices() {
  return (
    <>
    <div className="service-title text-green-38B652 font-700 mb-3 text-uppercase">SAMsa offices 
              </div>
              <div className="service-box mb-5 mb-sm-4">For any inquiries or assistance, please feel free to contact us. You can find the specific contact details for each of our regional offices listed below. We are here to help.</div>

              <div className="row g-3 g-sm-3">
                <div className="col-lg-5 col-md-6 col-sm-6">
                        <p className="font-17 text-primary-color"><b>PRETORIA</b></p>
                        <p className="font-17 text-primary-color">Tel: +27 (0) 12 366 2600</p>
                        <p className="font-17 text-primary-color">Fax: +27 (0) 12 366 2601</p>
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <p className="font-17 text-primary-color"><b>​DURBAN</b></p>
                        <p className="font-17 text-primary-color">Tel: +27 (0) 31 307 ​1501</p>
                        <p className="font-17 text-primary-color">Fax: +27 (0) 31 306 4983</p>
                        <p className="font-17 text-primary-color">Email: <a href='mailto:durbanops@samsa.org.za'>durbanops@samsa.org.za</a></p>
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <p className="font-17 text-primary-color"><b>​CAPE TOWN</b></p>
                        <p className="font-17 text-primary-color">Tel: +27 (0) 21 421 6170​​</p>
                        <p className="font-17 text-primary-color">Fax: +27 (0) 21 419 0730</p>
                        <p className="font-17 text-primary-color">Email: <a href='mailto:samsacpt@samsa.org.za'>samsacpt@samsa.org.za</a></p>
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <p className="font-17 text-primary-color"><b>PORT ELIZABETH</b></p>
                        <p className="font-17 text-primary-color">Tel: +27 (0) 41 585 0051/3</p>
                        <p className="font-17 text-primary-color">Fax: +27 (0) 41 582 1213</p>
                        <p className="font-17 text-primary-color">Email: <a href='mailto:pereception@samsa.org.za'>pereception@samsa.org.za</a></p>
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <p className="font-17 text-primary-color"><b>PORT NOLLOTH​</b></p>
                        <p className="font-17 text-primary-color">Tel: +27 (0) 27 851 7695</p>
                        <p className="font-17 text-primary-color">Fax: +27 (0) 27 851 7699</p>
                        <p className="font-17 text-primary-color">Email: <a href='mailto:portnolloth@samsa.org.za'>portnolloth@samsa.org.za</a></p>
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <p className="font-17 text-primary-color"><b>​RICHARDS BAY</b></p>
                        <p className="font-17 text-primary-color">Tel: +27 (0) 35 788 0068</p>
                        <p className="font-17 text-primary-color">Fax: +27 (0) 35 788 00</p>
                        <p className="font-17 text-primary-color">Email: <a href='mailto:samsarb@samsa.org.za'>samsarb@samsa.org.za</a></p>
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <p className="font-17 text-primary-color"><b>​EAST LONDON</b></p>
                        <p className="font-17 text-primary-color">Tel: +27 (0) 43 722 4120 </p>
                        <p className="font-17 text-primary-color">Fax: +27 (0) 43 722 2264</p>
                        <p className="font-17 text-primary-color">Email: <a href='mailto:elreception@samsa.org.za'>elreception@samsa.org.za</a></p>
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <p className="font-17 text-primary-color"><b>​SALDANHA BAY</b></p>
                        <p className="font-17 text-primary-color">Tel: +27 (0) 22 714 1612</p>
                        <p className="font-17 text-primary-color">Fax: +27 (0) 22 714 3635​​</p>
                        <p className="font-17 text-primary-color">Email: <a href='mailto:saldanhabayoffice@samsa.org.za'>saldanhabayoffice@samsa.org.za</a></p>
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <p className="font-17 text-primary-color"><b>​MOSSEL BAY</b></p>
                        <p className="font-17 text-primary-color">Tel: +27 (0) 44 690 4201</p>
                        <p className="font-17 text-primary-color">Fax: +27 (0) 44 691 1206</p>
                        <p className="font-17 text-primary-color">Email: <a href='mailto:mbreception@samsa.org.za'>mbreception@samsa.org.za</a></p>
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <p className="font-17 text-primary-color"><b>PORT OF NGQURA</b></p>
                        <p className="font-17 text-primary-color">Tel: (Cell)+27 (0)79 512 1017</p>
                        <p className="font-17 text-primary-color">Fax: +27 (0)​41 582 2130</p>
                        <p className="font-17 text-primary-color">Email: <a href='mailto:ponreception@samsa.org.za'>ponreception@samsa.org.za</a></p>
                    </div>
                    
                    {/* <div className="col-lg-5 col-md-6 col-sm-6">
                        <p className="font-17 text-primary-color"><b>PRET​EAST LONDON ORIA</b></p>
                        <p className="font-17 text-primary-color">Tel: +27 (0) 43 722 4120</p>
                        <p className="font-17 text-primary-color">Fax: +27 (0) 43 722 2264</p>
                        <p className="font-17 text-primary-color"><a href='mailto:'>Email: elreception@samsa.org.za</a></p>
                    </div> */}
                    
                    <div className="col-lg-5 col-md-6 col-sm-6">
                        <p className="font-17 text-primary-color"><b>​MRCC (CAPE TOWN)</b></p>
                        <p className="font-17 text-primary-color">Tel: +27 (0) 21 938 3310</p>
                        <p className="font-17 text-primary-color">Fax: +27 (0) 21 938 3319 </p>
                    </div>
              
              </div>
    </>
  )
}

export default SamsaOffices;